import { Button } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const CalenderViewButton = ({
  active,
  label,
  sx,
  size,
  variant,
  ...rest
}) => {
  return (
    <Button
      variant={active ? "outlined" : "text"}
      sx={(theme) => {
        return active
          ? {
              borderRadius: "17.5px",
              bgcolor: alpha(theme.palette.primary.light, 0.3),
              border: `1px solid ${theme.palette.primary.main}`,
              fontSize: "14px",
              fontWeight: 700,
              color: "text.primary",
              textTransform: "capitalize",
              height: "27px",
            }
          : {
              fontWeight: 500,
              color: "text.primary",
              textTransform: "capitalize",
              height: "27px",
            };
      }}
      disableRipple
      size="small"
      {...rest}
    >
      {label}
    </Button>
  );
};
